module.exports = __webpack_public_path__ + "img/tucson-hybrid-25.c1643731.png";